{
  "filters": "Filtres",
  "columns": "Colonnes",
  "chart": "Graphique",
  "addFilter": "Ajouter un filtre",
  "addColumn": "Ajouter une colonne",
  "field": "Champ",
  "comparison": "Comparaison",
  "value": "Valeur",
  "link": "Lien",
  "savedReport": "Rapport correctement enregistré",
  "downloadCsv": "Télécharger au format CSV",
  "dailyStats": "Statistiques quotidiennes",
  "subTradeRequest": "Demande de sous-opération",
  "client": "Client",
  "account": "Compte",
  "subAccount": "Sous-compte",
  "transfer": "Virement",
  "transaction": "Grand livre",
  "trade": "Opération",
  "clientGroup": "Groupe de clients",
  "goal": "Objectif",
  "day": "Jour",
  "week": "Semaine",
  "month": "Mois",
  "year": "Année",
  "newReport": "Nouveau rapport",
  "editReport": "Modifier le rapport",
  "download": "Télécharger",
  "accessTypes": {
    "ORGANIZATIONAL": "Organisationnel",
    "PUBLIC": "Public",
    "PRIVATE": "Privé"
  },
  "saveAs": {
    "modalButton": "Enregistrer sous",
    "title": "Enregistrer comme nouveau rapport",
    "name": "Nom",
    "accessType": "Type d'accès",
    "button": "Enregistrer sous"
  },
  "table": {
    "name": "Nom",
    "type": "Type",
    "accessType": "Type d'accès",
    "author": "Auteur",
    "organization": "Organisation"
  },
  "column": {
    "id": "Pièce d'identité",
    "targetAmountCents": "Montant cible en cents",
    "organizationName": "Organisation",
    "userId": "Identifiant de l'utilisateur",
    "primaryUserId": "Identifiant de l'utilisateur principal",
    "type": "Type",
    "source": "Source",
    "name": "Nom",
    "subAccountType": "Type de sous-compte",
    "subAccountSource": "Source du sous-compte",
    "subAccountName": "Nom du sous-compte",
    "amount": "Montant",
    "amountCents": "Montant (cents)",
    "failReason": "Motif de l'échec",
    "withdrawalReason": "Motif du retrait",
    "withdrawalReasonDescription": "Description du motif de retrait",
    "adjustmentReason": "Motif de l'ajustement",
    "isWithdrawAll": "Correspond à un retrait intégral",
    "isAdjustment": "Correspond à un ajustement",
    "instantInvest": "Investissement instantané",
    "description": "Description",
    "financialProductName": "Nom du produit financier",
    "financialProductId": "Identifiant du produit financier",
    "financialProductTicker": "Symbole du titre financier",
    "accountId": "Identifiant du compte",
    "accountType": "Type de compte",
    "accountState": "État du compte",
    "accountCustodianAccountNumber": "Numéro du dépositaire du compte",
    "accountCreatedAt": "Compte créé à",
    "accountUpdatedAt": "Compte mis à jour à",
    "signedAllFormsAt": "Totalité des formulaires signée à",
    "approvedAt": "Approuvé à",
    "subAccountSignedAllFormsAt": "Totalité des formulaires du sous-compte signée à",
    "subAccountApprovedAt": "Approbation du sous-compte à",
    "subAccountCreatedAt": "Création du sous-compte à",
    "subAccountUpdatedAt": "Mise à jour du sous-compte à",
    "reconciledAt": "Rapproché à",
    "effectiveDate": "Date d'entrée en vigueur",
    "subAccountId": "Identifiant du sous-compte",
    "subAccountState": "État du sous-compte",
    "subAccountFinancialProductId": "Identifiant du portefeuille de modèles du sous-compte",
    "subAccountCompletedAt": "Sous-compte finalisé à",
    "userLink": "Lien du client",
    "primaryUserLink": "Lien de l'utilisateur principal",
    "search": "Recherche",
    "accountTypes": "Types de compte",
    "firstName": "Prénom",
    "middleName": "Deuxième prénom",
    "lastName": "Nom de famille",
    "state": "État",
    "primaryEmail": "Courriel",
    "phone": "Numéro de téléphone",
    "streetAddress": "Adresse postale",
    "province": "Province",
    "city": "Ville",
    "dateOfBirth": "Date de naissance",
    "foreignTaxCountry": "Pays d'imposition étranger",
    "citizenships": "Citoyennetés",
    "companyType": "Type d'entreprise",
    "jobTitle": "Titre du poste",
    "studentAreaOfStudy": "Domaine d'étude",
    "investmentKnowledge": "Connaissances des investissements",
    "employmentStatus": "Situation d'emploi",
    "complianceState": "État de conformité",
    "complianceIssueSource": "Source du problème de conformité",
    "iDCheckCompleted": "Vérification de l'identité terminée",
    "lastSuitabilityReviewAt": "Dernier examen d'adéquation à",
    "suitabilityScore": "Score d'adéquation",
    "language": "Langue",
    "timezone": "Fuseau horaire",
    "maritalStatus": "État civil",
    "riskQuestion1": "Première question de risque",
    "riskQuestion2": "Deuxième question de risque",
    "createdAt": "Créé à",
    "updatedAt": "Mis à jour à",
    "completedAt": "Terminé à",
    "marketValueCents": "Valeur du marché",
    "annualIncomeCents": "Revenu annuel (cents)",
    "financialFixedAssetsCents": "Actifs immobilisés (cents)",
    "financialLiquidAssetsCents": "Liquidités (cents)",
    "totalDebtCents": "Dette totale (cents)",
    "totalNetWorthCents": "Valeur nette totale (cents)",
    "moneyAvailableCents": "Liquidités disponibles (cents)",
    "netContributionCents": "Contributions nettes (cents)",
    "newContributionCents": "Nouvelles contributions (cents)",
    "pendingContributionCents": "Contributions en attente (cents)",
    "cashOnHoldToTradeCents": "Liquidités en attente de négociation (cents)",
    "cashOnHoldToWithdrawCents": "Liquidités en attente de retrait (cents)",
    "marketValue": "Valeur du marché",
    "annualIncome": "Revenu annuel",
    "financialFixedAssets": "Actifs immobilisés",
    "financialLiquidAssets": "Liquidités",
    "totalDebt": "Dette totale",
    "totalNetWorth": "Valeur nette totale",
    "moneyAvailable": "Trésorerie disponible",
    "netContribution": "Contributions nettes",
    "pendingContribution": "Contributions en attente",
    "cashOnHoldToTrade": "Trésorerie en attente de négociation",
    "cashOnHoldToWithdraw": "Trésorerie en attente de retrait",
    "newContribution": "Nouvelles contributions",
    "custodianAccountNumber": "Numéro de compte du bénéficiaire",
    "primaryUserFirstName": "Prénom de l'utilisateur principal",
    "primaryUserMiddleName": "Deuxième prénom de l'utilisateur principal",
    "primaryUserLastName": "Nom de famille de l'utilisateur principal",
    "primaryUserState": "État de l'utilisateur principal",
    "primaryUserPrimaryEmail": "Courriel de l'utilisateur principal",
    "primaryUserPhone": "Numéro de téléphone de l'utilisateur principal",
    "primaryUserStreetAddress": "Adresse postale de l'utilisateur principal",
    "primaryUserProvince": "Province de l'utilisateur principal",
    "primaryUserCity": "Ville de l'utilisateur principal",
    "primaryUserDateOfBirth": "Date de naissance de l'utilisateur principal",
    "primaryUserCompanyType": "Type d'entreprise de l'utilisateur principal",
    "primaryUserJobTitle": "Titre du poste de l'utilisateur principal",
    "primaryUserStudentAreaOfStudy": "Domaine d'étude de l'utilisateur principal",
    "primaryUserInvestmentKnowledge": "Connaissances en investissement de l'utilisateur principal",
    "primaryUserEmploymentStatus": "Situation d'emploi de l'utilisateur principal",
    "primaryUserComplianceState": "État de conformité de l'utilisateur principal",
    "primaryUserSuitabilityScore": "Score d'adéquation de l'utilisateur principal",
    "primaryUserLanguage": "Langue de l'utilisateur principal",
    "primaryUserTimezone": "Fuseau horaire de l'utilisateur principal",
    "primaryUserMaritalStatus": "État civil de l'utilisateur principal",
    "primaryUserRiskQuestion1": "Première question de risque de l'utilisateur principal",
    "primaryUserRiskQuestion2": "Seconde question de risque de l'utilisateur principal",
    "primaryUserComplianceIssueSource": "Source du problème de conformité de l'utilisateur principal",
    "primaryUserIDCheckCompleted": "Vérification de l'identité de l'utilisateur principale terminée",
    "primaryUserLastSuitabilityReviewAt": "Dernier examen d'adéquation de l'utilisateur principal à",
    "primaryUserCreatedAt": "Utilisateur principal créé à",
    "primaryUserUpdatedAt": "Utilisateur principal mis à jour à",
    "primaryUserCompletedAt": "Utilisateur principal finalisé à",
    "primaryUserMarketValueCents": "Valeur de marché de l'utilisateur principal (cents)",
    "primaryUserAnnualIncomeCents": "Revenu annuel de l'utilisateur principal (cents)",
    "primaryUserFinancialFixedAssetsCents": "Actifs immobilisés de l'utilisateur principal (cents)",
    "primaryUserFinancialLiquidAssetsCents": "Liquidités de l'utilisateur principal (cents)",
    "primaryUserTotalDebtCents": "Dette totale de l'utilisateur principal (cents)",
    "primaryUserTotalNetWorthCents": "Valeur nette totale de l'utilisateur principal (cents)",
    "primaryUserMoneyAvailableCents": "Trésorerie disponible de l'utilisateur principal (cents)",
    "primaryUserNetContributionCents": "Contributions nettes de l'utilisateur principal (cents)",
    "primaryUserNewContributionCents": "Nouvelles contributions de l'utilisateur principal (cents)",
    "primaryUserPendingContributionCents": "Contributions en attente de l'utilisateur principal (cents)",
    "primaryUserCashOnHoldToTradeCents": "Liquidités en attente de négociation de l'utilisateur principal (cents)",
    "primaryUserCashOnHoldToWithdrawCents": "Liquidités en attente de retrait de l'utilisateur principal (cents)",
    "primaryUserMarketValue": "Valeur de marché de l'utilisateur principal",
    "primaryUserAnnualIncome": "Revenu annuel de l'utilisateur principal",
    "primaryUserFinancialFixedAssets": "Actifs immobilisés de l'utilisateur principal",
    "primaryUserFinancialLiquidAssets": "Liquidités de l'utilisateur principal",
    "primaryUserTotalDebt": "Dette totale de l'utilisateur principal",
    "primaryUserTotalNetWorth": "Valeur nette totale de l'utilisateur principal",
    "primaryUserMoneyAvailable": "Trésorerie disponible de l'utilisateur principal",
    "primaryUserNetContribution": "Contributions nettes de l'utilisateur principal",
    "primaryUserPendingContribution": "Contributions en attente de l'utilisateur principal",
    "primaryUserCashOnHoldToTrade": "Liquidités en attente de négociation de l'utilisateur principal",
    "primaryUserCashOnHoldToWithdraw": "Liquidités en attente de retrait de l'utilisateur principal",
    "primaryUserNewContribution": "Nouvelles contributions de l'utilisateur principal",
    "primaryUserEntityName": "Nom de l'entité de l'utilisateur principal",
    "userFirstName": "Prénom du client",
    "userMiddleName": "Deuxième prénom du client",
    "userLastName": "Nom de famille du client",
    "userState": "État du client",
    "userPrimaryEmail": "Courriel du client",
    "userPhone": "Téléphone du client",
    "userStreetAddress": "Adresse résidentielle du client",
    "userProvince": "Province du client",
    "userCity": "Ville du client",
    "userDateOfBirth": "Date de naissance du client",
    "userCompanyType": "Type de compagnie du client",
    "userJobTitle": "Poste du client",
    "userStudentAreaOfStudy": "Domaine d'études du client",
    "userInvestmentKnowledge": "Connaissances d'investissement du client",
    "userEmploymentStatus": "Statut d'emploi du client",
    "userComplianceState": "État de conformité du client",
    "userSuitabilityScore": "Score d'adéquation du client",
    "userLanguage": "Langue du client",
    "userTimezone": "Fuseau horaire du client",
    "userMaritalStatus": "État civil du client",
    "userRiskQuestion1": "Première question de risque du client",
    "userRiskQuestion2": "Deuxième question de risque du client",
    "userComplianceIssueSource": "Source du problème de conformité du client",
    "userPoliticallyExposedDomesticPerson": "Personne politiquement exposée nationale du client",
    "userPoliticallyExposedForeignPerson": "Personne politiquement exposée étrangère du client",
    "userHeadOfInternationalOrganization": "Chef d'organisation internationale du client",
    "userIDCheckCompleted": "Vérification de l'identité du client terminée",
    "userLastSuitabilityReviewAt": "Dernier exercice de convenance du client à",
    "userCreatedAt": "Client créé à",
    "userUpdatedAt": "Client mis à jour à",
    "userCompletedAt": "Client complété à",
    "userMarketValueCents": "Valeur marchande du client (cents)",
    "userAnnualIncomeCents": "Revenu annuel du client (cents)",
    "userFinancialFixedAssetsCents": "Actifs immobilisés du client (cents)",
    "userFinancialLiquidAssetsCents": "Liquidités du client (en cents)",
    "userTotalDebtCents": "Client Dette totale (cents)",
    "userTotalNetWorthCents": "Client valeur nette totale (cents)",
    "userMoneyAvailableCents": "Client liquidités disponibles (cents)",
    "userNetContributionCents": "Client contributions nettes (cents)",
    "userNewContributionCents": "Client nouvelles contributions (cents)",
    "userPendingContributionCents": "Client contributions en attente (cents)",
    "userCashOnHoldToTradeCents": "Liquidités du client en attente d'être négociées (cents)",
    "userCashOnHoldToWithdrawCents": "Liquidités du client en attente de retrait (cents)",
    "userMarketValue": "Valeur marchande du client",
    "userAnnualIncome": "Revenu annuel du client",
    "userFinancialFixedAssets": "Actifs immobilisés du client",
    "userFinancialLiquidAssets": "Liquidités du client",
    "userTotalDebt": "Client Dette totale",
    "userTotalNetWorth": "Client valeur nette totale",
    "userMoneyAvailable": "Client liquidités disponibles",
    "userNetContribution": "Client contributions nettes",
    "userPendingContribution": "Client contributions en attente",
    "userCashOnHoldToTrade": "Liquidités du client en attente d'être négociées",
    "userCashOnHoldToWithdraw": "Liquidités du client en attente de retrait",
    "userNewContribution": "Client nouvelles contributions",
    "userEntityName": "Nom de l'entité du client",
    "accountMarketValueCents": "Valeur marchande du compte (cents)",
    "accountMoneyAvailableCents": "Client liquidités disponibles (cents)",
    "accountNetContributionCents": "Client contributions nettes (cents)",
    "accountNewContributionCents": "Client nouvelles contributions (cents)",
    "accountPendingContributionCents": "Client contributions en attente (cents)",
    "accountCashOnHoldToTradeCents": "Liquidités du client en attente d'être négociées (cents)",
    "accountCashOnHoldToWithdrawCents": "Liquidités en attente de retrait (cents)",
    "accountMarketValue": "Valeur marchande du compte",
    "accountMoneyAvailable": "Liquidités du compte disponibles",
    "accountNetContribution": "Client contributions nettes",
    "accountPendingContribution": "Client contributions en attente",
    "accountCashOnHoldToTrade": "Liquidités du client en attente d'être négociées",
    "accountCashOnHoldToWithdraw": "Liquidités du client en attente de retrait",
    "accountNewContribution": "Client nouvelles contributions",
    "subAccountMoneyAvailableCents": "Sous-compte Liquidités disponibles (cents)",
    "subAccountNetContributionCents": "Sous-compte Contributions nettes (cents)",
    "subAccountNewContributionCents": "Sous-compte nouvelles contributions (cents)",
    "subAccountPendingContributionCents": "Sous-compte contributions en attente (cents)",
    "subAccountCashOnHoldToTradeCents": "Sous-compte Liquidités à négocier (cents)",
    "subAccountCashOnHoldToWithdrawCents": "Sous-compte Liquidités à retirer (cents)",
    "subAccountMarketValue": "Valeur marchande du sous-compte",
    "subAccountMoneyAvailable": "Sous-compte Liquidités disponibles",
    "subAccountNetContribution": "Sous-compte Contributions nettes",
    "subAccountPendingContribution": "Sous-compte contributions en attente",
    "subAccountCashOnHoldToTrade": "Liquidités du sous-compte en attente d'être négociées",
    "subAccountCashOnHoldToWithdraw": "Liquidités du sous-compte en attente de retrait",
    "subAccountNewContribution": "Sous-compte nouvelles contributions",
    "organization": "Organisation",
    "deactivatedAt": "Désactivé à",
    "frozenAt": "Gelé à",
    "reviewingAt": "Révision à",
    "readyAt": "Prêt à",
    "requestedAt": "Demandé à",
    "processingAt": "Traitement à",
    "failedAt": "Échoué à",
    "canceledAt": "Annulé à",
    "activatedAt": "Activé à",
    "allSigned": "Tous les documents signés",
    "isOfficerOfPublicCompany": "Officié d'une entreprise publique",
    "isOwnerOfPublicCompany": "Propriétaire d'une entreprise publique",
    "isMemberOfIiroc": "Est membre de l'Iiroc",
    "politicallyExposedForeignPerson": "Personne étrangère politiquement exposée",
    "politicallyExposedDomesticPerson": "Personne locale politiquement exposée",
    "closeAssociateOfPEP": "Associé proche d'une PPE",
    "powerOfAttorneyGranted": "Procuration accordée",
    "headOfInternationalOrganization": "Responsable d'une organisation internationale",
    "isSuspicious": "Suspicieux",
    "suspiciousRules": "Règles suspicieuses",
    "suspiciousState": "État suspicieux",
    "settleDate": "Date de règlement",
    "date": "Date",
    "quantity": "Quantité",
    "subAccountFinancialProductName": "Identifiant du portefeuille de modèles du sous-compte",
    "valueCents": "Valeur en cents",
    "goalId": "ID de l'objectif",
    "goalName": "Nom de l'objectif",
    "goalType": "Type d'objectif",
    "goalTimeHorizon": "Horizon temporel de l'objectif",
    "goalTargetAmountCents": "Montant cible en cents",
    "feeTierId": "ID du niveau de redevance",
    "feeTierName": "Nom du palier de frais",
    "feeTierState": "Niveau de redevance État",
    "clientGroupId": "Groupe de clients",
    "clientGroupName": "Nom du groupe de clients",
    "clientGroupType": "Groupe de clients",
    "clientGroupState": "État du groupe de clients",
    "clientGroupPrimaryUserId": "ID de l'utilisateur primaire de groupe client",
    "clientGroupFeeTierId": "ID de frais du groupe client",
    "clientGroupFeeTierState": "Groupe de clients Niveau d'honoraires État",
    "clientGroupFeeTierName": "Groupe de clients Niveau d'honoraires État",
    "affiliateOnly": "Affilié uniquement",
    "currency": "Devise",
    "moneyAllocatedCents": "Fonds alloués",
    "expectedTradePriceCents": "Prix prévu",
    "actualQuantity": "Quantité réelle",
    "expectedQuantity": "Quantité attendue",
    "actualTradePriceCents": "Prix négocié actuel",
    "percentageFilled": "Pourcentage rempli",
    "timeHorizon": "Horizon temporel",
    "tradeSecurity": "Échange d'actions",
    "moneyAllocated": "Fonds alloués",
    "expectedTradePrice": "Prix prévu",
    "actualTradePrice": "Prix négocié actuel",
    "uniqueCircumstances": "Circonstances uniques",
    "sourceOfWealth": "Source des richesses",
    "sourceOfWealthOtherDescription": "Description de la source des richesses",
    "sourceOfFunds": "Sources des fonds",
    "sourceOfFundsOtherDescription": "Description de la source des fonds",
    "preferredMethodOfCommunication": "Moyen de communication préféré:",
    "preferredMethodOfCommunicationOtherDescription": "Description du moyen de communication préféré",
    "employerName": "Nom de l'employeur",
    "payTaxesOutsideCanada": "Paiement d'impôts en dehors du Canada",
    "trustedContactPersonName": "Personne de confiance à contacter",
    "trustedContactPersonEmail": "Courriel de personne de confiance",
    "trustedContactPersonPhone": "Téléphone de personne de confiance",
    "trustedContactPersonCity": "Ville de personne de confiance",
    "trustedContactPersonProvince": "Province de personne de confiance",
    "trustedContactPersonRelation": "Relation de personne de confiance",
    "spouseFirstName": "Prénom du conjoint",
    "spouseLastName": "Nom du conjoint",
    "spouseEmail": "Courriel du conjoint",
    "spouseEmploymentType": "Type d'emploi du conjoint",
    "spouseCompanyType": "Type de l'entreprise du conjoint",
    "spouseJobTitle": "Occupation du conjoint",
    "spouseDateOfBirth": "Date de naissance du conjoint",
    "spouseAddressProvince": "Province du conjoint",
    "spouseAddressCity": "Ville du conjoint",
    "employerCompanyAddress": "Adresse de l'employeur",
    "numberOfClients": "# Clients",
    "numberOfFundedClients": "# Nombre de clients financés",
    "calculatedAt": "Calculé à",
    "isAccreditedInvestor": "Est un investisseur accrédité",
    "isVulnerablePerson": "Est une personne vulnérable",
    "iDVerified": "Identité vérifiée",
    "entityName": "Nom de l'entité",
    "exchange": "Change",
    "ticker": "Symbole",
    "scheduleNextDate": "Programmer la prochaine date",
    "actualTradePriceInCurrencyCents": "Cours réel en centimes",
    "preSplitMaxQuantity": "Quantité max. avant fractionnement",
    "blockedUntil": "Bloqué jusqu'à",
    "blockedUntilSubAccountActive": "Bloqué jusqu'à ce que le sous-compte soit actif",
    "blockedUntilAccountActive": "Bloqué jusqu'à ce que le compte soit actif",
    "blockedUntilPairActualTradePriceCents": "Bloquer jusqu'au cours réel de la paire en centimes",
    "maxQuantity": "Quantité maximale",
    "publishedAt": "Publié à",
    "isSuggestedByOptimizer": "Est suggéré par l'optimiseur",
    "verificationRequired": "Vérification requise",
    "isPartial": "Est Partiel",
    "isSellAll": "Est Tout vendre",
    "originalCurrency": "Devise originale",
    "preSplitMoneyAllocated": "Somme allouée avant fractionnement",
    "settlementDays": "Jours de règlement",
    "settlementDate": "Date de règlement",
    "volatile": "Volatile",
    "verifiedByUser": "Vérifié par l'utilisateur",
    "verifiedAt": "Vérifié à",
    "initiatedAt": "Initié à",
    "accountBaseCurrency": "Devise de base du compte",
    "organizationBaseCurrency": "Devise de base de l'organisation",
    "moneyAvailableInOrgCurrency": "Liquidités disponibles dans la devise de l'organisation",
    "netContributionInOrgCurrency": "Contributions nettes dans la devise de l'organisation",
    "newContributionInOrgCurrency": "Nouvelles contributions dans la devise de l'organisation",
    "pendingContributionInOrgCurrency": "Contributions en attente dans la devise de l'organisation",
    "cashOnHoldToTradeInOrgCurrency": "Trésorerie en attente de négociation dans la devise de l'organisation",
    "cashOnHoldToWithdrawInOrgCurrency": "Trésorerie en attente de retrait dans la devise de l'organisation",
    "marketValueInOrgCurrency": "Valeur marchande dans la devise de l'organisation",
    "moneyAvailableCentsInOrgCurrency": "Liquidités disponibles dans la devise de l'organisation (cents)",
    "netContributionCentsInOrgCurrency": "Contributions nettes dans la devise de l'organisation (cents)",
    "newContributionCentsInOrgCurrency": "Nouvelles contributions dans la devise de l'organisation (cents)",
    "pendingContributionCentsInOrgCurrency": "Contributions en attente dans la devise de l'organisation (cents)",
    "cashOnHoldToTradeCentsInOrgCurrency": "Trésorerie en attente de négociation dans la devise de l'organisation (cents)",
    "cashOnHoldToWithdrawCentsInOrgCurrency": "Trésorerie en attente de retrait dans la devise de l'organisation (cents)",
    "marketValueCentsInOrgCurrency": "Valeur marchande dans la devise de l'organisation (cents)",
    "fraudRisk": "Risque de fraude",
    "tradingProcess": "Processus commercial",
    "fatcaStatus": "Statut FATCA",
    "householdId": "ID du ménage",
    "householdLink": "Lien du ménage",
    "userAccountGroupId": "ID du groupe de comptes utilisateur",
    "householdAccountGroupId": "ID du groupe de comptes du ménage",
    "organizationAccountGroupId": "ID du groupe de comptes de l'organisation",
    "accountRepCode": "Code de représentant de compte",
    "accountRepCodes": "Codes de représentant de compte",
    "repCode": "Code de représentant"
  },
  "chartType": "Type de graphique",
  "groupOn": "Regrouper selon",
  "title": "Titre",
  "valueAggregation": "Agrégation",
  "formatTitle": "Format",
  "valueFieldTitle": "Champ avec valeur",
  "groupingType": "Type de regroupement",
  "interval": "Intervalle",
  "reportType": "Type de rapport",
  "addWidget": "Ajouter un widget",
  "successSaveDashboard": "Le tableau de bord a bien été enregistré",
  "inheritedDashboardReadOnly": "Ce tableau de bord appartient à une organisation parente. La mise en page et les widgets ne peuvent pas être enregistrés depuis cette organisation.",
  "addModal": {
    "title": "Nouveau tableau de bord",
    "name": "Nom",
    "organization": "Organisation"
  },
  "chartTypes": {
    "BAR": "Graphique en barres",
    "LINE": "Graphique en courbe",
    "NUMBER": "Valeur numérique",
    "PIE": "Graphique circulaire"
  },
  "aggregationTypes": {
    "AVG": "Moyenne",
    "SUM": "Somme",
    "VALUE_COUNT": "Nombre"
  },
  "valueField": {
    "id": "ID",
    "marketValueCents": "Valeur du marché",
    "amountCents": "Montant",
    "valueCents": "Valeur"
  },
  "format": {
    "CENTS": "Dollar",
    "FLOAT": "Numéro"
  },
  "groupingTypes": {
    "DATE": "Date",
    "FIRST_DATE_IN_INTERVAL": "Premier dans l'intervalle",
    "GROUPING": "Groupe",
    "SINGLE_VALUE": "Valeur unique"
  },
  "intervals": {
    "DAY": "Jour",
    "MONTH": "Mois",
    "WEEK": "Semaine",
    "YEAR": "Année"
  },
  "reportTypes": {
    "ACCOUNT": "Compte",
    "DAILY_STATS": "Statistiques quotidiennes",
    "HISTORY": "Historique",
    "SUB_ACCOUNT": "Sous-comptes",
    "TRANSFER": "Virements",
    "USER": "Utilisateur",
    "TRANSACTION": "Transaction",
    "GOAL": "Objectif",
    "CLIENT_GROUP": "Ménages",
    "TRADE": "Opération",
    "SUB_TRADE_REQUEST": "Demande de sous-opération"
  },
  "comparisons": {
    "TEXT_SEARCH": "recherche",
    "EQUALS": "est égal à",
    "NOT_EQUALS": "n'est pas égal à",
    "INCLUDES": "inclut",
    "NOT_INCLUDES": "n'inclut pas",
    "GREATER_THAN": "supérieur à",
    "LESS_THAN": "inférieur à",
    "GREATER_THAN_AGO": "il y a plus de",
    "LESS_THAN_AGO": "il y a moins de",
    "IN": "dans",
    "NOT_TEXT_SEARCH": "ne recherche pas"
  },
  "globalFilters": {
    "ruleChip": "{{type}} {{field}} {{comparison}} {{value}}",
    "label": "Filtres globaux",
    "addRule": "Ajouter une règle globale",
    "clearRules": "Effacer les règles actives ({{count}})",
    "editTitle": "Modifier les filtres globaux",
    "appliesToWidgets": "S'applique à {{count}} widgets de ce type",
    "appliesToNoWidgets": "Aucun widget de ce type sur ce tableau de bord",
    "widgetBadge": "Filtré",
    "appliedToWidget": "{{count}} filtres globaux appliqués"
  },
  "widgetError": "Impossible d'afficher ce widget",
  "widgetOptionsError": "Impossible de charger les options du rapport. Fermez et réessayez.",
  "successRenameDashboard": "Tableau de bord renommé avec succès",
  "unsavedTitle": "Annuler les modifications non enregistrées?",
  "unsavedBody": "Vous avez des modifications non enregistrées sur ce tableau de bord. Si vous quittez maintenant, ces modifications seront perdues.",
  "discardChanges": "Annuler",
  "untitledDashboard": "Tableau de bord sans titre",
  "renameModal": {
    "title": "Renommer le tableau de bord",
    "name": "Nom"
  },
  "a11y": {
    "moreActions": "Plus d'actions"
  },
  "dashboardMenu": {
    "rename": "Renommer",
    "copyFrom": "Copier depuis un autre tableau de bord"
  },
  "addWidgetPlaceholder": {
    "title": "Ajouter un widget"
  },
  "copyFrom": {
    "title": "Copier depuis un autre tableau de bord",
    "source": "Tableau de bord à copier",
    "noSources": "Il n'y a pas d'autres tableaux de bord à copier.",
    "truncated": "Affichage des {{shown}} premiers tableaux de bord.",
    "summary": "Copie {{widgetCount}} widgets ({{reportTypes}}) et tous les filtres globaux.",
    "emptySource": "Ce tableau de bord n'a aucun widget à copier.",
    "replaceWarning": "Ceci remplacera les {{widgetCount}} widgets et les {{filterCount}} filtres globaux déjà présents sur ce tableau de bord.",
    "unsavedHint": "Rien n'est enregistré tant que vous n'avez pas sauvegardé le tableau de bord.",
    "confirm": "Remplacer les widgets",
    "success": "Widgets copiés. Enregistrez le tableau de bord pour les conserver."
  }
}
